export default "__VITE_ASSET__3cc0354e__"